import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { AccordionTextList } from 'AtomicContainers'
import { SpecificationListItem } from "containers"
import { omit } from "utils"

/**
 * Specification List
 * @returns {ReactElement} React Component
 */
export const SpecificationList = (props) => {
  const accordionProps = omit(["specs"], props)
  const { specs } = props

  return (
    <AccordionTextList
      alwaysOpen={props.alwaysOpen}
      data={specs.map((category,index)=>{
      return {
        title: category.name,
        onClick: category.onClick,
        description: category.items.map((item, index) => (
          item.name && (
            <SpecificationListItem
              gtmEventsDisclaimers={props.gtmEventsDisclaimers}
              key={index}
              {...item} />
          )
        ))
      }
    })
    } />
  )
}

SpecificationList.propTypes = {
  specs: PropTypes.array,
  alwaysOpen: PropTypes.bool
}

export default Radium(SpecificationList)



// WEBPACK FOOTER //
// ./src/containers/specification-list/index.jsx